/* eslint-disable react/jsx-filename-extension */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Form } from 'antd';

import DrawerSubmitFooter from '../common/containers/DrawerSubmitFooter';
import FormTextInput from '../common/inputs/FormTextInput';
import DivisionSelector from '../common/inputs/DivisionSelector';

const formLabelStyle = {
  style: {
    paddingBottom: 5,
    marginTop: 10,
  },
};

export default function MaterialFolderAddDrawer({
  item,
  visible,
  onClose,
  onSubmit,
  divisionFilter,
}) {
  const [form] = Form.useForm();
  const [selectedDivisions, setSelectedDivisions] = useState(item?.divisionIds ?? []);

  const onSubmitClicked = useCallback(async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (err) {
      // Failed
    }
  }, [onSubmit, form]);

  useEffect(() => {
    if (visible) {
      setSelectedDivisions(item?.divisionIds ?? []);
      return;
    }
    const reset = async () => {
      await form.resetFields();
    };
    reset();
  }, [visible, item, form]);

  return (
    <Drawer
      title={item?.id ? 'Edit Folder' : 'Add Folder'}
      width={400}
      visible={visible}
      onClose={onClose}
    >
      <Form
        layout="vertical"
        form={form}
        className="materials-add-drawer-form"
        initialValues={item}
      >
        <FormTextInput
          name="name"
          label="Name"
          isNotDisplay
          rules={[
            { required: true, message: 'Please enter a name' },
          ]}
        />
        <Form.Item
          name="divisionIds"
          label="Divisions"
          style={{ marginBottom: 0, paddingBottom: -8 }}
          labelCol={formLabelStyle}
          rules={[{ required: true, message: 'Please select at least one division' }]}
          valuePropName="divisionIds"
        >
          <DivisionSelector
            mode="multiple"
            divisions={selectedDivisions}
            onChange={setSelectedDivisions}
            filter={divisionFilter}
          />
        </Form.Item>
      </Form>
      <DrawerSubmitFooter
        onClose={onClose}
        onSubmit={onSubmitClicked}
      />
    </Drawer>
  );
}

MaterialFolderAddDrawer.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    divisionIds: PropTypes.arrayOf(PropTypes.string),
  }),
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  divisionFilter: PropTypes.instanceOf(Set),
};

MaterialFolderAddDrawer.defaultProps = {
  item: null,
  visible: false,
  divisionFilter: undefined,
};
